/* eslint-disable react/prop-types */
import petIcon from '@common/_assets/images/Brand_Logo_Ruff_Mews_FullBody_1.svg';
import { PetPhoto } from '@common/components/photo';
import { IntakePetModel } from '@common/models';
import { ImageResizerUtil } from '@common/utils';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';

export interface IPetPhotoUploadProps {
    isReadOnly: boolean;
    intakePet: IntakePetModel;
    onPhotoChanged: (photoToSave: File) => Promise<void>;
}

const PetPhotoUploadWithForwardedRef = React.forwardRef<HTMLInputElement, IPetPhotoUploadProps>(({ isReadOnly, intakePet, onPhotoChanged }: IPetPhotoUploadProps, ref) => {
    const hiddenFileInput = React.useRef<HTMLInputElement | null>(null);

    const handleImageUploadClick = useCallback((e: any) => {
        if (hiddenFileInput?.current) {
            hiddenFileInput.current.click();
            e.stopPropagation();
        }

    }, [hiddenFileInput]);

    const handleChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length) {
            const fileUploaded: File = e.target.files[0];
            if (fileUploaded) {
                const resizedPhoto = await ImageResizerUtil.ResizeImage(fileUploaded, { saveMaxWidth: 640, saveMaxHeight: 640 });
                onPhotoChanged(resizedPhoto);
            }
        }
    }, [onPhotoChanged]);

    return (
        <>
            <div className={classNames("circle-image", { clickable: !isReadOnly })} onClick={handleImageUploadClick}>
                <PetPhoto photo={intakePet.photo} petName={intakePet.name} speciesPlaceHolderOverride={petIcon} height={60} width={60} />
            </div>

            <input
                accept="image/*"
                style={{ display: "none" }}
                id="petPhoto"
                name="petPhoto"
                type="file"
                multiple={false}
                ref={hiddenFileInput}
                onChange={handleChange}
            />

            <p>Tap to add pet photo</p>
        </>
    )
});

PetPhotoUploadWithForwardedRef.displayName = "PetPhotoUpload";

export const PetPhotoUpload = observer(PetPhotoUploadWithForwardedRef);
